var _path, _path2;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgLogOutMobile(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    draggable: "false",
    width: 24,
    height: 24,
    viewBox: "0 0 24 24",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M15.6 8.4L17 7L22 12L17 17L15.6 15.6L18.2 13H8V11L18.2 11L15.6 8.4Z"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M3.99994 5L11.9999 5L11.9999 3L3.99994 3C2.89994 3 1.99994 3.9 1.99994 5L1.99994 19C1.99994 20.1 2.89994 21 3.99994 21L11.9999 21L11.9999 19L3.99994 19L3.99994 5Z"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgLogOutMobile);
export default __webpack_public_path__ + "static/media/log-out-mobile.d5017fa8.svg";
export { ForwardRef as ReactComponent };